import { Responsive, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './Description.css';
import { CollapsedBlock } from '../CollapsedBlock';

interface IDescriptionProps {
  description: string;
}
export const Description = (props: IDescriptionProps): React.JSX.Element => {
  return (
    <div className={styles['description']}>
      <Responsive desktop>
        <UIText2 color="current_color">
          <div
            // oxlint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{ __html: props.description }}
            className={styles['text']}
          />
        </UIText2>
      </Responsive>
      <Responsive tablet phone>
        <CollapsedBlock collapsedHeight={60}>
          <UIText2 color="current_color">{props.description}</UIText2>
        </CollapsedBlock>
      </Responsive>
    </div>
  );
};
